import { useState, FormEvent } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { setAdminPassword } from '../shared/authConfig';
import './AdminLogin.css';

export default function AdminLogin() {
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const handleSubmit = (e: FormEvent) => {
        e.preventDefault();
        setError('');

        if (!password) {
            setError('Please enter a password');
            return;
        }

        // Save password to localStorage using centralized config
        setAdminPassword(password);

        // Get the redirect path from query params, default to /melaba
        const redirectTo = searchParams.get('redirect') || '/melaba';

        // Redirect to the admin page
        navigate(redirectTo);
    };

    return (
        <div className="admin-login-container">
            <div className="admin-login-card">
                <h1>🔒 Admin Access</h1>
                <p className="admin-login-subtitle">Please enter the admin password to continue</p>

                <form onSubmit={handleSubmit} className="admin-login-form">
                    <div className="form-group">
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter admin password"
                            className="admin-password-input"
                            autoFocus
                        />
                    </div>

                    {error && (
                        <div className="error-message">
                            {error}
                        </div>
                    )}

                    <button type="submit" className="admin-login-button">
                        Access Admin Panel
                    </button>
                </form>
            </div>
        </div>
    );
}
